export default __webpack_public_path__ + "static/media/0292.07ab02e7.jpg";